import React from 'react';
import {
  IconMail,
  IconPhone,
  IconMapPin,
  IconCake,
  IconCalendarEvent,
  IconWorld,
  IconBriefcase,
  IconBuildingStore,
} from '@tabler/icons-react';
import { useApp } from '../context/AppContext';
import Layout from '../components/Layout';
import ClientCapsules from '../components/ClientCapsules';

function initialsOf(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
}

const FIELDS = [
  { key: 'role', label: 'Role', Icon: IconBriefcase },
  { key: 'gmail', label: 'Gmail', Icon: IconMail },
  { key: 'contact_number', label: 'Contact number', Icon: IconPhone },
  { key: 'timezone', label: 'Timezone', Icon: IconWorld },
  { key: 'date_of_hire', label: 'Date hired', Icon: IconCalendarEvent },
  { key: 'birthday', label: 'Birthday', Icon: IconCake },
  { key: 'address', label: 'Address', Icon: IconMapPin },
];

function Field({ Icon, label, value }) {
  return (
    <div>
      <div className="flex items-center gap-1.5 text-[11px] sm:text-xs font-medium text-muted uppercase tracking-wide">
        <Icon size={14} stroke={1.8} className="text-bronze" />
        {label}
      </div>
      <p className="mt-1.5 text-sm sm:text-base font-medium text-ink break-words">{value || '—'}</p>
    </div>
  );
}

export default function Profile() {
  const { currentUser, clientStaff, clients } = useApp();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-6 sm:py-10">
        <h1 className="text-lg sm:text-xl font-semibold text-ink">Profile</h1>
        <p className="text-xs sm:text-sm text-muted mt-1">
          Pulled from the team list — read-only for now.
        </p>

        <div className="bg-card border border-border rounded-2xl shadow-sm p-5 sm:p-8 mt-6">
          <div className="flex flex-col items-center text-center sm:flex-row sm:items-center sm:text-left gap-5 pb-8 border-b border-border">
            <div className="w-20 h-20 rounded-full bg-gold text-white flex items-center justify-center text-2xl font-semibold flex-shrink-0">
              {initialsOf(currentUser.name)}
            </div>
            <div className="min-w-0">
              <p className="text-xl sm:text-2xl font-semibold text-ink truncate">{currentUser.name}</p>
              <span className="inline-block mt-2 text-xs font-medium uppercase tracking-wide text-bronze bg-card-tint px-2.5 py-1 rounded-full">
                {currentUser.role}
              </span>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6 sm:gap-y-7 pt-8">
            {FIELDS.map((field) => (
              <Field
                key={field.key}
                Icon={field.Icon}
                label={field.label}
                value={currentUser[field.key]}
              />
            ))}
          </div>

          <div className="pt-8 mt-8 border-t border-border">
            <div className="flex items-center gap-1.5 text-[11px] sm:text-xs font-medium text-muted uppercase tracking-wide mb-2">
              <IconBuildingStore size={14} stroke={1.8} className="text-bronze" />
              Clients
            </div>
            <ClientCapsules uuid={currentUser.uuid} clientStaff={clientStaff} clients={clients} />
          </div>
        </div>
      </div>
    </Layout>
  );
}
